import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import showToast from '@/utils/toasts';
import actions from '../constants';
import SubscriptionToast from '../components/SubscriptionToast';

export function* subscribeToast({ event }) {
  yield call(showToast, <SubscriptionToast event={event} isSubscribed />);
}

export function* unSubscribeToast({ event }) {
  yield call(showToast, <SubscriptionToast event={event} />);
}

export default function* subscriptionsToasts() {
  yield takeEvery(actions.TOGGLE_SUBSCRIBE_SUCCESS, subscribeToast);
  yield takeEvery(actions.TOGGLE_UNSUBSCRIBE_SUCCESS, unSubscribeToast);
}
